const inicialState = {
  textRtf: '',
  idRtf: 0,
  plainText: '',
  editorReadOnly: false,
  medExecutante: 0,
  medRevisor: 0,
  status: 'pendente',
  mensagem: '',
  tipo: 'sucesso',
  headerFooterRtf: '',
};

export default inicialState;



// WEBPACK FOOTER //
// ./src/pages/laudo/editor/editor.state.js